// src/data/productData.js

const productData = [
  {
    id: 1,
    name: "GlowAura Serum",
    price: 799,
    image: "/images/serum.jpg",
    shortDescription: "Brightening facial serum for radiant skin.",
    ingredients: [
      "Vitamin C", "Hyaluronic Acid", "Aloe Vera", "Licorice Root", "Niacinamide"
    ],
    reviews: [
      { user: "Meera", comment: "Loved the glow it gave my skin!", rating: 5 },
      { user: "Riya", comment: "Smooth texture and smells amazing.", rating: 4 }
    ]
  },
  {
    id: 2,
    name: "Herbal Cleanser",
    price: 499,
    image: "/images/cleanser.jpg",
    shortDescription: "Gentle cleanser with herbal extracts.",
    ingredients: [
      "Aloe Vera Juice", "Green Tea Extract", "Chamomile Extract", "Cucumber Extract", "Lavender Essential Oil"
    ],
    reviews: [
      { user: "Kavya", comment: "So gentle and calming!", rating: 5 },
      { user: "Snehal", comment: "Perfect for my sensitive skin.", rating: 4 }
    ]
  },
  {
    id: 3,
    name: "Botanical Toner",
    price: 450,
    image: "/images/toner.jpg",
    shortDescription: "Refreshing toner with natural botanicals.",
    ingredients: [
      "Rose Water", "Witch Hazel", "Aloe Vera", "Geranium Oil", "Green Tea Extract"
    ],
    reviews: [
      { user: "Anu", comment: "Tightens pores and smells lovely.", rating: 4 },
      { user: "Namrata", comment: "Leaves my skin feeling fresh.", rating: 5 }
    ]
  },
  {
    id: 4,
    name: "Hydrating Cream",
    price: 649,
    image: "/images/cream.jpg",
    shortDescription: "Deeply moisturizing cream for dry skin.",
    ingredients: [
      "Shea Butter", "Hyaluronic Acid", "Aloe Vera", "Vitamin E", "Oat Extract"
    ],
    reviews: [
      { user: "Divya", comment: "My skin stays hydrated all day!", rating: 5 },
      { user: "Nisha", comment: "Great for winter dryness.", rating: 5 }
    ]
  },
  {
    id: 5,
    name: "Rose Lip Balm",
    price: 199,
    image: "/images/lipbalm.jpg",
    shortDescription: "Natural lip balm with rose and shea butter.",
    ingredients: ["Beeswax", "Shea Butter", "Rose Extract", "Vitamin E"],
    reviews: [
      { user: "Sneha", comment: "Super soft lips and amazing scent!", rating: 5 },
      { user: "Tina", comment: "Long-lasting moisture.", rating: 4 }
    ]
  },
  {
    id: 6,
    name: "Turmeric Face Mask",
    price: 349,
    image: "/images/mask.jpg",
    shortDescription: "Detoxifying face mask with turmeric and clay.",
    ingredients: ["Turmeric", "Bentonite Clay", "Aloe Vera", "Neem Extract"],
    reviews: [
      { user: "Aarav", comment: "Reduced acne visibly!", rating: 5 },
      { user: "Simran", comment: "Skin feels refreshed and clean.", rating: 4 }
    ]
  },
  {
    id: 7,
    name: "Lavender Body Lotion",
    price: 599,
    image: "/images/lotion.jpg",
    shortDescription: "Relaxing lavender body moisturizer.",
    ingredients: ["Lavender Oil", "Coconut Oil", "Shea Butter", "Glycerin"],
    reviews: [
      { user: "Ritu", comment: "Soothing and non-greasy.", rating: 4 },
      { user: "Farah", comment: "Calming scent before bed.", rating: 5 }
    ]
  },
  {
    id: 8,
    name: "Cucumber Eye Gel",
    price: 329,
    image: "/images/eye_gel.jpg",
    shortDescription: "Cooling under-eye gel for puffiness.",
    ingredients: ["Cucumber Extract", "Aloe Vera", "Vitamin C", "Green Tea"],
    reviews: [
      { user: "Asha", comment: "Great for morning puffiness.", rating: 4 },
      { user: "Rohini", comment: "Feels cool and light on skin.", rating: 5 }
    ]
  },
  {
    id: 9,
    name: "Neem Face Wash",
    price: 399,
    image: "/images/facewash.jpg",
    shortDescription: "Anti-acne neem face wash for daily use.",
    ingredients: ["Neem", "Tea Tree Oil", "Salicylic Acid", "Aloe Vera"],
    reviews: [
      { user: "Yash", comment: "My acne reduced in a week!", rating: 5 },
      { user: "Ishita", comment: "Leaves skin clean and oil-free.", rating: 4 }
    ]
  },
  {
    id: 10,
    name: "Charcoal Scrub",
    price: 429,
    image: "/images/scrub.jpg",
    shortDescription: "Deep-cleansing charcoal face scrub.",
    ingredients: ["Activated Charcoal", "Walnut Powder", "Aloe Vera"],
    reviews: [
      { user: "Rajan", comment: "Removes blackheads very well.", rating: 5 },
      { user: "Preeti", comment: "Love the mild exfoliation.", rating: 4 }
    ]
  },
  {
    id: 11,
    name: "Mint Foot Cream",
    price: 349,
    image: "/images/footcream.jpg",
    shortDescription: "Refreshing mint cream for tired feet.",
    ingredients: ["Peppermint Oil", "Shea Butter", "Tea Tree Oil"],
    reviews: [
      { user: "Neha", comment: "My feet feel so relaxed!", rating: 5 },
      { user: "Mansi", comment: "Cooling effect is amazing.", rating: 4 }
    ]
  },
  {
    id: 12,
    name: "Aloe Night Gel",
    price: 459,
    image: "/images/nightgel.jpg",
    shortDescription: "Light gel for overnight hydration.",
    ingredients: ["Aloe Vera", "Green Tea", "Niacinamide", "Licorice Extract"],
    reviews: [
      { user: "Sanya", comment: "Woke up with soft skin!", rating: 5 },
      { user: "Disha", comment: "Very soothing and non-sticky.", rating: 4 }
    ]
  },
  {
    id: 13,
    name: "Coconut Hair Serum",
    price: 499,
    image: "/images/hairserum.jpg",
    shortDescription: "Nourishing serum for frizz-free hair.",
    ingredients: ["Coconut Oil", "Argan Oil", "Vitamin E"],
    reviews: [
      { user: "Aditi", comment: "Tamed my frizz in minutes!", rating: 5 },
      { user: "Sonal", comment: "Hair feels soft and shiny.", rating: 4 }
    ]
  },
  {
    id: 14,
    name: "Brightening Face Oil",
    price: 699,
    image: "/images/faceoil.jpg",
    shortDescription: "Radiance-boosting oil for glowing skin.",
    ingredients: ["Rosehip Oil", "Sea Buckthorn", "Vitamin C"],
    reviews: [
      { user: "Bhavya", comment: "Skin looks radiant after a week.", rating: 5 },
      { user: "Naina", comment: "Not greasy and absorbs well.", rating: 4 }
    ]
  },
  {
    id: 15,
    name: "Sandalwood Face Mist",
    price: 299,
    image: "/images/facemist.jpg",
    shortDescription: "Hydrating facial mist with sandalwood.",
    ingredients: ["Sandalwood Hydrosol", "Rose Water", "Aloe Vera"],
    reviews: [
      { user: "Ira", comment: "Perfect refreshment on hot days.", rating: 5 },
      { user: "Diya", comment: "Smells divine and feels fresh.", rating: 4 }
    ]
  }
];

export default productData;
